import { render, staticRenderFns } from "./ComplaintDetailResponse.vue?vue&type=template&id=2ef56591&"
import script from "./ComplaintDetailResponse.vue?vue&type=script&lang=js&"
export * from "./ComplaintDetailResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports